const ACTIVATION_TARGETS = {
  profit: 'profit_on_gdv',
  roc: 'profit_on_gdc',
  roce: 'roce',
}

export function appraisalTargetFromCriteria(criteria = {}) {
  const configuredCriteria = [
    [criteria.primaryMetric, criteria.primaryThreshold],
    [criteria.secondaryMetric, criteria.secondaryThreshold],
  ]

  const criterion = configuredCriteria.find(([metric, threshold]) => (
    ACTIVATION_TARGETS[String(metric ?? '').toLowerCase()] &&
    String(threshold ?? '').trim() !== ''
  ))

  if (!criterion) return { metric: 'roce', targetReturn: '' }
  const [metric, threshold] = criterion

  return {
    metric: ACTIVATION_TARGETS[String(metric).toLowerCase()],
    targetReturn: String(threshold).trim(),
  }
}

export function appraisalTargetFromActivation(activation = {}) {
  const version = activation.workflowVersion ?? activation.workflow_version ?? 1
  return appraisalTargetFromCriteria(Number(version) >= 2 ? activation.step4 : activation.step5)
}

export function roceTargetFromCriteria(criteria = {}) {
  const target = appraisalTargetFromCriteria(criteria)

  return target.metric === 'roce' ? target.targetReturn : ''
}

export function roceTargetFromActivation(activation = {}) {
  const target = appraisalTargetFromActivation(activation)

  return target.metric === 'roce' ? target.targetReturn : ''
}
